import { useEffect } from 'react';

/**
 * Sets the `--app-height` CSS custom property on `<html>` to the current
 * `window.innerHeight` and keeps it in sync on resize and orientation changes.
 *
 * This fixes the "100vh too tall" problem on mobile browsers where the address
 * bar / navigation bar covers part of the layout. The CSS variable is consumed
 * throughout the app instead of bare `100vh`.
 *
 * Call this hook once at the top-level router component. No arguments needed.
 */
export const useViewportHeight = (): void => {
    useEffect(() => {
        const update = () => {
            document.documentElement.style.setProperty(
                '--app-height',
                `${window.innerHeight}px`
            );
        };

        update();
        window.addEventListener('resize', update);
        window.addEventListener('orientationchange', update);

        return () => {
            window.removeEventListener('resize', update);
            window.removeEventListener('orientationchange', update);
        };
    }, []);
};
